export default __webpack_public_path__ + "static/contact-BR-f554bbebf6975ce9c56c24c96c3d40da.svg";